export default __webpack_public_path__ + "static/media/mobile_90s.e57bd10b.jpg";